//@Version 1.0.0
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
   name: 'sanitizerHtml',
   standalone: false
})
export class SanitizerHtmlPipe implements PipeTransform {

   constructor( private sanitizer : DomSanitizer ) { }

   transform(value: string): SafeHtml {   
      return this.sanitizer.bypassSecurityTrustHtml(value);
   }

}
